import React from 'react'
import { bindActionCreators } from 'redux'
import { Route } from 'react-router-dom'
import { push } from 'connected-react-router'
import { connect } from 'react-redux'
import { FocusStyleManager, Spinner } from '@blueprintjs/core'

import * as paths from 'src/constants/paths'
import Home from './routes/Home'
import Runbook from './routes/Runbook'
import RunbooksList from './routes/Runbooks'
import TemplateActionListPage from './routes/Runbooks/TemplateActionListPage'
import Solutions from './routes/Cmdb/Solutions'
import ConfigurationItems from './routes/Cmdb/ConfigurationItems'
import Contacts from './routes/Cmdb/Contacts'
import Status from './routes/Cmdb/Status'
import Logout from './routes/Logout'
import Documentation from './routes/Documentation/'
import RunbookGraph from './routes/RunbookGraph'
import ToastManager from './components/ToastManager'
import { setActiveRunbook } from './store/modules/ui/runbook'
import { getRunbook } from 'src/store/modules/runbooks'
import { bulkUpdateActions } from './store/modules/runbooks/actions'
import { subscribeToGlobal } from './utils/websockets'
import { initApp } from 'src/store/modules/app'
import withAuth from 'src/HOCs/withAuth'
import Header from './components/Header'
import './app.scss'

FocusStyleManager.onlyShowFocusOnTabs()

class App extends React.Component {
    handleNavigation = (path) => (e) => {
        e.preventDefault()

        if (path === paths.NEW_PATH) {
            this.props.actions.setActiveRunbook(null)
        }

        // hack to prevent runbooks to get stuck in infinite loading
        // TODO: find a better way to approach the location change action in the reducer
        // if ((this.props.pathname === '/runbooks' || this.props.pathname === '/runbooks/') && path === paths.LIST_PATH) {
        //     return
        // }
        this.props.dispatch(push(path))
    }

    componentDidMount() {
        const { actions } = this.props
        actions.initApp()
    }

    componentDidUpdate(prevProps) {
        const { dispatch, websocketConfig } = this.props

        // Initialize WebSocket connection once we have config
        if (!prevProps.websocketConfig && websocketConfig) {
            this.socket = subscribeToGlobal(
                (data) => {
                    if (data.actionType === 'update_actions') {
                        dispatch(
                            bulkUpdateActions(
                                data.payload.runbookId,
                                data.payload.updatedActions,
                                true
                            )
                        )
                    } else if (data.actionType === 'start_session') {
                        dispatch({
                            type: 'START_RUNBOOK_SESSION_SUCCESS',
                            runbookId: data.payload.runbookId,
                            data: data.payload,
                        })
                    } else if (data.actionType === 'end_session') {
                        dispatch({
                            type: 'END_RUNBOOK_SESSION_SUCCESS',
                            runbookId: data.payload.runbookId,
                            data: data.payload,
                        })
                    }
                },
                dispatch,
                websocketConfig
            )
        }
    }

    render() {
        const { loading } = this.props
        if (loading) {
            return <Spinner />
        }
        return (
            <>
                <ToastManager key={'toastManager'} />

                <Header />

                <Route exact path="/" component={Home} key={'main'} />
                <Route
                    exact
                    path={paths.LIST_PATH}
                    component={RunbooksList}
                    key={'listRunbooks'}
                />
                <Route
                    exact
                    path={paths.TEMPLATES_PATH}
                    component={RunbooksList}
                    key={'listRunbooksTemplates'}
                />
                <Route
                    exact
                    path={paths.TEMPLATE_DETAIL_PATH}
                    component={TemplateActionListPage}
                    key={'listRunbooksTemplateDetail'}
                />
                <Route
                    exact
                    path={paths.DETAIL_PATH}
                    component={Runbook}
                    key={'runbook'}
                />
                {/* CHECK ME - Likely unused, unreadable for bigger graphs */}
                <Route
                    exact
                    path={paths.GRAPH_PATH}
                    component={RunbookGraph}
                    key={'runbookGraph'}
                />
                <Route
                    exact
                    path={paths.CMDB_SOLUTIONS_PATH}
                    component={Solutions}
                    key={'cmdb-solutions'}
                />
                {/* DELETE ME - Hasn't worked since commit c5725bc49756be2d1c6b47aedd75419f0b19a788 */}
                <Route
                    exact
                    path={paths.CMDB_DEVICES_PATH}
                    component={ConfigurationItems}
                    key={'cmdb-devices'}
                />
                {/* CHECK ME - Likely unused, I doubt information here is up-to-date */}
                <Route
                    exact
                    path={paths.CMDB_CONTACTS_PATH}
                    component={Contacts}
                    key={'contacts'}
                />
                {/* CHECK ME - Unused but usable, no data ever put in production */}
                <Route
                    exact
                    path={paths.DOCUMENTATION_PATH + ':id/'}
                    component={Documentation}
                    key={'documentation'}
                />
                <Route
                    exact
                    path={paths.CMDB_STATUS_PATH}
                    component={Status}
                    key={'cmdb-status'}
                />
                <Route
                    exact
                    path={paths.LOGOUT_PATH}
                    component={Logout}
                    key={'logout'}
                />
            </>
        )
    }
}

const mapStateToProps = (state) => {
    const { pathname } = state.router.location
    return {
        pathname,
        userIsAdmin: state.app.isAdmin,
        runbook: getRunbook(state, state.ui.runbook.activeRunbook),
        loading: state.app.initialLoading,
        websocketConfig: state.app.websocketConfig,
    }
}

const mapDispatchToProps = (dispatch) => ({
    dispatch,
    actions: bindActionCreators(
        {
            setActiveRunbook,
            initApp,
        },
        dispatch
    ),
})

export default withAuth(connect(mapStateToProps, mapDispatchToProps)(App))
